// components/LoadingScreen.jsx
import React from "react"

const LoadingScreen = ({ isLoading }) => {
  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50"
      style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
    >
      <style>{`@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap');`}</style>

      {/* Spinner */}
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-zinc-900 mb-6" />

      {/* Text */}
      <p className="text-[18px] font-semibold text-zinc-800 tracking-tight mb-1 font-satoshi">
        Getting ready
      </p>
      <p
        className="text-[16px] text-zinc-500 font-satoshi"
      >
        joining in just a moment...
      </p>
    </div>
  )
}

export default LoadingScreen